import { Alert, Box, Chip, Typography } from '@mui/material';

const AVAILABILITY_HELP = {
  assigned: 'Past/completed day with a winner.',
  pending_day_completion: 'Live or past day without a finalized fan yet.',
  not_available_yet: 'Future / scheduled — not available yet.',
};

function FanOfTheDayPanel({ fanOfTheDay }) {
  const availability = fanOfTheDay?.availability || 'not_available_yet';
  const fan = fanOfTheDay?.fan || null;

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Fan of the Day is computed from FE daily stats — read-only in admin. No editor.
      </Alert>

      <Chip
        label={availability}
        color={availability === 'assigned' ? 'success' : 'default'}
        sx={{ mb: 2 }}
      />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {AVAILABILITY_HELP[availability] || availability}
      </Typography>

      {fan ? (
        <Box
          sx={{
            p: 2,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            maxWidth: 420,
          }}
        >
          <Typography variant="h6">{fan.display_name || fan.username || '—'}</Typography>
          {fan.username && (
            <Typography variant="body2" color="text.secondary">
              @{fan.username}
            </Typography>
          )}
          <Typography variant="body2" sx={{ mt: 1 }}>
            User ID: {fan.user_id ?? '—'}
          </Typography>
          <Typography variant="body2">
            FE earned: <strong>{fan.fe_earned ?? '—'}</strong>
          </Typography>
        </Box>
      ) : (
        <Typography color="text.secondary">No fan assigned yet.</Typography>
      )}
    </Box>
  );
}

export default FanOfTheDayPanel;
